/**
 * Base data for upload mock in the capital increase modal.
 * Paste here the object with shareClassId, holdingClassName and partners.
 *
 * When pressing "Upload mock" these data are converted into movements, historyMovements
 * and transactions in the modal.
 */
export type BaseDataPartner = {
  partnerId: string;
  partnerName: string;
  rangeFrom: number;
  rangeTo: number;
  sharesToIncrease: number;
  sharePremium?: number;
};

export type BaseDataForCapitalIncrease = {
  shareClassId: string;
  holdingClassName: string;
  partners: BaseDataPartner[];
};

export const baseDataForCapitalIncrease: BaseDataForCapitalIncrease = {
  shareClassId: '691ef0d152d180304cef0341',
  holdingClassName: 'Ordinaria',
  partners: [
    // Paste here the partners with: partnerId, partnerName, rangeFrom, rangeTo, sharesToIncrease, sharePremium
  ],
};
